import { proxy } from 'valtio'
import { getTerm } from '@app/helpers/workkeysReplaceTerms'

interface HeaderTitleType {
  title: string;
}

const initialState: HeaderTitleType = {
  title: getTerm('MasteryPrep')
};

export const HeaderTitleState = proxy<HeaderTitleType>(initialState);

export const setHeaderTitle = (title: string) => {
  HeaderTitleState.title = title
}

export const resetHeaderTitleState = () => {
  HeaderTitleState.title = initialState.title
}